import { createPortal } from 'react-dom'

import { Typography } from '@/components/ui'

interface IDescriptionTooltipProps {
	x: number
	y: number
	description: string
}

const DescriptionTooltip = ({
	x,
	y,
	description
}: IDescriptionTooltipProps) => {
	return createPortal(
		<Typography
			variant='text'
			style={{
				left: x,
				top: y
			}}
			className='pointer-events-none fixed z-[9999] min-w-[350px] max-w-[500px] rounded-[12px] bg-yellow-300 p-5 !text-[16px] text-left text-gray-600 shadow-[0_8px_24px_rgba(0,0,0,0.16)]'
		>
			{description}
		</Typography>,
		document.body
	)
}

export default DescriptionTooltip
